// Blog pages are plain HTML from the server (spec §18). This small script adds
// what the app's own pages do: a cookieless page view, and sign-up links that
// carry where the visit came from, so new accounts are credited to the blog
// (and to the article) when the visit had no campaign tags of its own.
import { trackPageView, withSource } from './analytics.ts';

trackPageView();

const slug = /^\/blog\/([a-z0-9-]+)$/.exec(location.pathname)?.[1];
for (const a of document.querySelectorAll<HTMLAnchorElement>('a[data-signup]')) {
  const url = new URL(withSource(a.getAttribute('href')!), location.origin);
  if (!url.searchParams.has('utm_source')) {
    url.searchParams.set('utm_source', 'blog');
    url.searchParams.set('utm_medium', slug ? 'article' : 'index');
    if (slug) url.searchParams.set('utm_campaign', slug);
  }
  a.href = url.pathname + url.search;
}
